<template>
  <div v-show="show">
    <el-row>
      <el-col :span="24">
        <el-tabs :tab-position="bottom" style="height: 200px; margin-top: 20px;">
          <el-tab-pane :label="$t('pensionbasicde.general')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount1">{{$t('pensionbasicde.save')}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('pensionbasicde.Temporaryreturn')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.holidaystarttime')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-date-picker type="date" placeholder="" value-format="yyyy-MM-dd" v-model="form4.holidaystarttime" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.holidayendtime')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-date-picker type="date" placeholder="" value-format="yyyy-MM-dd" v-model="form4.holidayendtime" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account3">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount2">{{$t('pensionbasicde.save')}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('pensionbasicde.retroactivepayment')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.retroactivepaymentmonth')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.etroactivetime" placeholder="">
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.retroactivepayment')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-input v-model.number="form4.etroactiveamount"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account4">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount3">{{$t('pensionbasicde.save')}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('pensionbasicde.latedelivery')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.latedelivery')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.latedeliverymonth" placeholder="">
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.latedelivery')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.latedeliverybun" placeholder=" ">
                    <el-option v-for="item in daysbun" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account5">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount4">{{$t('pensionbasicde.save')}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane :label="$t('pensionbasicde.midcareer')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.companyinformation')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">{{$t('pensionbasicde.Settlementday')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.galarycode1" placeholder="">
                    <el-option label="毎月１０日" value="code110"></el-option>
                    <el-option label="毎月２０日" value="code220"></el-option>
                    <el-option label="毎月月末" value="code332"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="1">{{$t('pensionbasicde.payday')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.galarycode2" placeholder="">
                    <el-option label="当月２５日" value="code2k25"></el-option>
                    <el-option label="当月月末" value="code2k32"></el-option>
                    <el-option label="翌月２５日" value="code2l25"></el-option>
                    <el-option label="翌月月末" value="code2l32"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <hr />
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.entertime')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-date-picker type="date" placeholder="" value-format="yyyy-MM-dd" v-model="form4.membertime" style="width: 100%;"></el-date-picker>
                </el-col>

                <el-col :span="4">
                  <el-button type="primary" @click="accountdays">{{$t('pensionbasicde.Automaticcalculation')}}
                  </el-button>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account2">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount5">{{$t('pensionbasicde.save')}}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane :label="$t('pensionbasicde.parttime')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account6">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount7">{{$t('pensionbasicde.save')}}
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('pensionbasicde.reducedworking')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account7">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount8">{{$t('pensionbasicde.save')}}
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('pensionbasicde.leave')">
            <el-form ref="form4" :model="form4" label-width="80px">
              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.member')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.member" placeholder="">
                    <el-option v-for="item in emp" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content placement="top-start">
                    <el-button>{{$t('pensionbasicde.leaveofabsence')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="4">
                  <el-select v-model="form4.lowdeliverymonth" placeholder="">
                    <el-option v-for="item in month" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.april')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days4" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency4"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks4" @blur="add4"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total4" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑭{{$t('pensionbasicde.grandtotal')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total14" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.may')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days5" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency5"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks5" @blur="add5"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total5" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑮ {{$t('pensionbasicde.average')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.average" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-col :span="1">
                  <el-tooltip class="item" effect="dark" content="" placement="top-start">
                    <el-button>{{$t('pensionbasicde.june')}}</el-button>
                  </el-tooltip>
                </el-col>
                <el-col :span="2">⑩ {{$t('pensionbasicde.workingdays')}}</el-col>
                <el-col :span="2">
                  <el-select v-model="form4.days6" placeholder="">
                    <el-option v-for="item in days" :key="item.key" :label="item.label" :value="item.codeid">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="1">⑪{{$t('pensionbasicde.currency')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.currency6"></el-input>
                </el-col>
                <el-col :span="1">⑫{{$t('pensionbasicde.stocks')}}</el-col>
                <el-col :span="2">
                  <el-input v-model.number="form4.stocks6" @blur="add6"></el-input>
                </el-col>
                <el-col :span="3">⑬{{$t('pensionbasicde.total')}}（⑪ ＋ ⑫）</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.total6" readonly="readonly"></el-input>
                </el-col>
                <el-col :span="3">⑯{{$t('pensionbasicde.adjustedaverage')}}</el-col>
                <el-col :span="3">
                  <el-input v-model="form4.adjustedaverage" readonly="readonly"></el-input>
                </el-col>
              </el-form-item>

              <hr />

              <el-form-item>
                <el-button type="primary" @click="account8">{{$t('pensionbasicde.payoff')}}</el-button>
                <el-button @click="clearall">{{$t('pensionbasicde.clear')}}</el-button>
                <el-button type="primary" @click="insertpensionaccount6">{{$t('pensionbasicde.save')}}
                </el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      loading: false,
      tabPosition: "left",
      form4: {
        member: "",
        days4: "",
        days5: "",
        days6: "",
        currency4: "",
        currency5: "",
        currency6: "",
        stocks4: "",
        stocks5: "",
        stocks6: "",
        total4: "",
        total5: "",
        total6: "",
        total14: "",
        average: "",
        adjustedaverage: "",
        mes: "",
        etroactivetime: "",
        etroactiveamount: "",
        latedeliverymonth: "",
        latedeliverybun: "",
        lowdeliverymonth: ""
      },

      days: [{
        codeid: "0",
        label: "0日"
      },
      {
        codeid: "1",
        label: "1日"
      },
      {
        codeid: "2",
        label: "2日"
      },
      {
        codeid: "3",
        label: "3日"
      },
      {
        codeid: "4",
        label: "4日"
      },
      {
        codeid: "5",
        label: "5日"
      },
      {
        codeid: "6",
        label: "6日"
      },
      {
        codeid: "7",
        label: "7日"
      },
      {
        codeid: "8",
        label: "8日"
      },
      {
        codeid: "9",
        label: "9日"
      },
      {
        codeid: "10",
        label: "10日"
      },
      {
        codeid: "11",
        label: "11日"
      },
      {
        codeid: "12",
        label: "12日"
      },
      {
        codeid: "13",
        label: "13日"
      },
      {
        codeid: "14",
        label: "14日"
      },
      {
        codeid: "15",
        label: "15日"
      },
      {
        codeid: "16",
        label: "16日"
      },
      {
        codeid: "17",
        label: "17日"
      },
      {
        codeid: "18",
        label: "18日"
      },
      {
        codeid: "19",
        label: "19日"
      },
      {
        codeid: "20",
        label: "20日"
      },
      {
        codeid: "21",
        label: "21日"
      },
      {
        codeid: "22",
        label: "22日"
      },
      {
        codeid: "23",
        label: "23日"
      },
      {
        codeid: "24",
        label: "24日"
      },
      {
        codeid: "25",
        label: "25日"
      },
      {
        codeid: "26",
        label: "26日"
      },
      {
        codeid: "27",
        label: "27日"
      },
      {
        codeid: "28",
        label: "28日"
      },
      {
        codeid: "29",
        label: "29日"
      },
      {
        codeid: "30",
        label: "30日"
      },
      {
        codeid: "31",
        label: "31日"
      }
      ],
      daysbun: [{
        codeid: "1",
        label: "1日分"
      },
      {
        codeid: "2",
        label: "2日分"
      },
      {
        codeid: "3",
        label: "3日分"
      },
      {
        codeid: "4",
        label: "4日分"
      },
      {
        codeid: "5",
        label: "5日分"
      },
      {
        codeid: "6",
        label: "6日分"
      },
      {
        codeid: "7",
        label: "7日分"
      },
      {
        codeid: "8",
        label: "8日分"
      },
      {
        codeid: "9",
        label: "9日分"
      },
      {
        codeid: "10",
        label: "10日分"
      },
      {
        codeid: "11",
        label: "11日分"
      },
      {
        codeid: "12",
        label: "12日分"
      },
      {
        codeid: "13",
        label: "13日分"
      },
      {
        codeid: "14",
        label: "14日分"
      },
      {
        codeid: "15",
        label: "15日分"
      },
      {
        codeid: "16",
        label: "16日分"
      },
      {
        codeid: "17",
        label: "17日分"
      },
      {
        codeid: "18",
        label: "18日分"
      },
      {
        codeid: "19",
        label: "19日分"
      },
      {
        codeid: "20",
        label: "20日分"
      },
      {
        codeid: "21",
        label: "21日分"
      },
      {
        codeid: "22",
        label: "22日分"
      },
      {
        codeid: "23",
        label: "23日分"
      },
      {
        codeid: "24",
        label: "24日分"
      },
      {
        codeid: "25",
        label: "25日分"
      },
      {
        codeid: "26",
        label: "26日分"
      },
      {
        codeid: "27",
        label: "27日分"
      },
      {
        codeid: "28",
        label: "28日分"
      },
      {
        codeid: "29",
        label: "29日分"
      },
      {
        codeid: "30",
        label: "30日分"
      },
      {
        codeid: "31",
        label: "31日分"
      }
      ],
      month: [{
        codeid: "4",
        label: "4月"
      },
      {
        codeid: "5",
        label: "5月"
      },
      {
        codeid: "6",
        label: "6月"
      }
      ],
      emp: []
    };
  },
  methods: {
    clearall() {
      this.form4.member = "";
      this.form4.days4 = "";
      this.form4.days5 = "";
      this.form4.days6 = "";
      this.form4.currency4 = "";
      this.form4.currency5 = "";
      this.form4.currency6 = "";
      this.form4.stocks4 = "";
      this.form4.stocks5 = "";
      this.form4.stocks6 = "";
      this.form4.total4 = "";
      this.form4.total5 = "";
      this.form4.total6 = "";
      this.form4.total14 = "";
      this.form4.average = "";
      this.form4.adjustedaverage = "";
    },

    insertpensionaccount1() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount1",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },

    insertpensionaccount2() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount2",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },

    insertpensionaccount3() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount3",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },

    insertpensionaccount4() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount4",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },
    insertpensionaccount5() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount5",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },
    insertpensionaccount6() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount6",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },

    insertpensionaccount7() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount7",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },

    insertpensionaccount8() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/insertpensionaccount8",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.$message({
            type: "success",
            message: this.$t("general.add_completed")
          });
        })
        .catch(function (error) {
          this.$message({
            type: "success",
            message: this.$t("general.add_failed")
          });
        });
    },

    add4() {
      console.log("add4 start");
      this.form4.total4 =
        parseInt(this.form4.currency4) + parseInt(this.form4.stocks4);
    },

    add5() {
      this.form4.total5 =
        parseInt(this.form4.currency5) + parseInt(this.form4.stocks5);
    },
    add6() {
      this.form4.total6 =
        parseInt(this.form4.currency6) + parseInt(this.form4.stocks6);
    },
    account() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    accountdays() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/accountdays",
        data: postData
      })
        .then(response => {
          this.form4.days4 = response.data.days4;
          this.form4.days5 = response.data.days5;
          this.form4.days6 = response.data.days6;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account2() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account2",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account3() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account3",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account4() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account4",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account5() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account5",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account6() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account6",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account7() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account7",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    account8() {
      let postData = this.qs.stringify(this.form4);

      this.axios({
        method: "post",
        url: "/account8",
        data: postData
      })
        .then(response => {
          console.log(response);
          this.form4.total4 = response.data.total4;
          this.form4.total5 = response.data.total5;
          this.form4.total6 = response.data.total6;
          this.form4.total14 = response.data.total14;
          this.form4.average = response.data.average;
          this.form4.adjustedaverage = response.data.adjustedaverage;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created() {
    this.axios
      .post("/listemp")
      .then(response => {
        this.emp = response.data;
      })
      .catch(error => {
        this.show = false;
        this.$message({ type: 'error', message: '開発中です。' });
        console.log(error);
      });
  }
};
</script>



<style scoped>
.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/PensionBasic.vue